import cx from "classnames";
import { FancyCheckmark } from "common/FancyCheckmark";
import { Icon } from "common/Icon";
import { CircleSpinner } from "common/spinners/CircleSpinner";
import { Popover } from "common/styleguide/Popover";
import React, { Fragment } from "react";
import styles from "./PopoverFilter.scss";

const DONE_SUCCESS = "done_success";
const DONE_ERROR = "done_error";
const PENDING = "pending";

export class PopoverFilter extends React.PureComponent {
  state = {
    expanded: false,
    status: null,
  };

  async toggleExpand(promise) {
    if (promise) {
      this.setState({ status: PENDING });
      try {
        await promise;
        this.setState({ status: DONE_SUCCESS });
        await new Promise((resolve) => setTimeout(resolve, 2000));
        this.setState({ status: null, expanded: false });
      } catch (e) {
        this.setState({ status: DONE_ERROR });
      }
    } else {
      !this.props.disabled && this.setState({ expanded: !this.state.expanded });
    }
  }

  render() {
    const { label, icon, innerLabel, hidePopoverLabel, children, className, disabled, disabledTitle, ...props } =
      this.props;
    const { expanded, status } = this.state;

    const popoverContent = (status) => {
      switch (status) {
        case PENDING:
          return (
            <div style={{ textAlign: "center" }}>
              <CircleSpinner />
            </div>
          );
        case DONE_SUCCESS:
          return (
            <div style={{ textAlign: "center" }}>
              <FancyCheckmark />
            </div>
          );
        case DONE_ERROR:
          return <div>Error</div>;
        default:
          if (typeof children === "function") {
            return children({
              toggleExpand: (optionalPromise) => this.toggleExpand(optionalPromise),
            });
          } else {
            return children;
          }
      }
    };

    const baseButtonProps = {
      onClick: () => this.toggleExpand(),
      ref: (r) => {
        this._trigger = r;
      },
      className: cx(className, expanded && styles.expanded),
    };
    const buttonProps = Object.assign(
      baseButtonProps,
      disabled && {
        disabled,
        "data-tip": true,
        title: disabled && disabledTitle,
      }
    );
    return (
      <Fragment>
        <FilterButton {...buttonProps}>
          {label} {!icon ? <Icon i="ios-arrow-down" /> : icon}
        </FilterButton>
        {!disabled && expanded && (
          <Popover onRequestClose={() => this.toggleExpand()} target={this._trigger} placement="bottom" {...props}>
            {!hidePopoverLabel && (
              <div className={styles.innerLabel}>{innerLabel === undefined ? label : innerLabel}:</div>
            )}
            {popoverContent(status)}
          </Popover>
        )}
      </Fragment>
    );
  }
}

export const FilterButton = React.forwardRef(({ className, children, valignCenter, disabled, ...props }, ref) => (
  <button
    className={cx(className, styles.trigger, valignCenter && styles.valignCenter, disabled && styles.disabled)}
    ref={ref}
    {...props}
  >
    {children}
  </button>
));
